import ViewpregnancyRecord from './PregnancyRecord/ViewpregnancyRecord';
import PregnancyRecord from './PregnancyRecord/PregnancyRecord';
import EditPregnancyRecord from './PregnancyRecord/EditPregnancyRecord';
import ViewChildrecord from './ChildRecord/ViewChildrecord';
import ChildRecord from './ChildRecord/ChildRecord';
import EditChildRecord from './ChildRecord/EditChildRecord';
import ViewMedicalrecord from './GeneralMedicalRecord/ViewMedicalrecord';
import MedicalRecord from './GeneralMedicalRecord/MedicalRecord';
import EditMedicalRecord from './GeneralMedicalRecord/EditMedicalRecord';
import ViewmomDiary from './MomDiary/ViewmomDiary';
import MomDiaryRecord from './MomDiary/MomDiaryRecord'
import EditmomDiary from './MomDiary/EditmomDiary';
import ViewPregnancyVitals from './PregnancyVitals/PregnancyVitalsView/ViewPregnancyVitals';
import AddVital from './PregnancyVitals/PregnancyVitalsView/AddVitals';
import EditVital from './PregnancyVitals/PregnancyVitalsView/EditVital';
import ViewSharemyrecord from './ShareMyRecord/ViewSharemyrecord';

const routes = [
  { path: "pregnancyrecord", component: ViewpregnancyRecord},
  { path: "addpregnancyrecord", component: PregnancyRecord },
  { path: "editpregnancyrecord/:id", component: EditPregnancyRecord},
  { path: "childrecord", component: ViewChildrecord},
  { path: "generalmedicalrecord", component: ViewMedicalrecord},
  { path: "addgeneralmedicalrecord", component: MedicalRecord},
  { path: "editmedicalrecord/:id", component: EditMedicalRecord},
  { path: "momdiary", component: ViewmomDiary},
  { path: "addmomdiary", component: MomDiaryRecord },
  { path: "editmomdiary/:id", component: EditmomDiary },
  { path: "pregnancyvitalrecord", component: AddVital},
  { path: "edit-vitals/:id", component: EditVital},
  { path: "addchildrecord", component: ChildRecord },
  { path: "editchildrecord/:id", component: EditChildRecord },
  { path: "pregnancyvitals", component: ViewPregnancyVitals},
  { path: "pregnancyvitals", component: ViewPregnancyVitals},
  { path: "sharemyrecord", component: ViewSharemyrecord }
]

export default routes;


// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/routes.js